/* (ignored) */


//////////////////
// WEBPACK FOOTER
// min-document (ignored)
// module id = 0
// module chunks = 18